var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "modal-backdrop" }, [
    _c("div", { staticClass: "modal-dialog modal-dialog-centered" }, [
      _c("div", { staticClass: "modal-content" }, [
        _c("div", { staticClass: "modal-header" }, [
          _c(
            "button",
            {
              staticClass: "close",
              attrs: { type: "button", "aria-label": "Close" },
              on: {
                click: function($event) {
                  return _vm.$emit("close")
                }
              }
            },
            [_c("i", { staticClass: "fa fa-times" })]
          ),
          _vm._v(" "),
          _c("h5", { staticClass: "modal-title" }, [
            _vm._v(_vm._s(_vm.isEdit ? "Edit Supergroup" : "Create Supergroup"))
          ])
        ]),
        _vm._v(" "),
        _c(
          "form",
          {
            on: {
              submit: function($event) {
                $event.preventDefault()
                return _vm.handleSubmit.apply(null, arguments)
              }
            }
          },
          [
            _c("div", { staticClass: "modal-body" }, [
              _c("div", { staticClass: "mb-3" }, [
                _c(
                  "label",
                  { staticClass: "form-label", attrs: { for: "name" } },
                  [_vm._v("Name")]
                ),
                _vm._v(" "),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.form.name,
                      expression: "form.name"
                    }
                  ],
                  staticClass: "form-control",
                  attrs: { id: "name", type: "text", required: "" },
                  domProps: { value: _vm.form.name },
                  on: {
                    input: function($event) {
                      if ($event.target.composing) return
                      _vm.$set(_vm.form, "name", $event.target.value)
                    }
                  }
                })
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "mb-3" }, [
                _c(
                  "label",
                  { staticClass: "form-label", attrs: { for: "parent_id" } },
                  [_vm._v("Parent Supergroup")]
                ),
                _vm._v(" "),
                _c(
                  "select",
                  {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.form.parent_id,
                        expression: "form.parent_id"
                      }
                    ],
                    staticClass: "form-select",
                    attrs: { id: "parent_id" },
                    on: {
                      change: function($event) {
                        var $$selectedVal = Array.prototype.filter
                          .call($event.target.options, function(o) {
                            return o.selected
                          })
                          .map(function(o) {
                            var val = "_value" in o ? o._value : o.value
                            return val
                          })
                        _vm.$set(
                          _vm.form,
                          "parent_id",
                          $event.target.multiple
                            ? $$selectedVal
                            : $$selectedVal[0]
                        )
                      }
                    }
                  },
                  [
                    _c("option", { attrs: { value: "" } }, [
                      _vm._v("None (Root Level)")
                    ]),
                    _vm._v(" "),
                    _vm._l(_vm.supergroupsWithHierarchy, function(sg) {
                      return _c(
                        "option",
                        {
                          key: sg.uuid,
                          attrs: {
                            disabled:
                              _vm.selectedSupergroup &&
                              sg.uuid === _vm.selectedSupergroup.uuid
                          },
                          domProps: { value: sg.uuid }
                        },
                        [
                          _vm._v(
                            "\n                " +
                              _vm._s(sg.displayName) +
                              "\n              "
                          )
                        ]
                      )
                    })
                  ],
                  2
                )
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "mb-3" }, [
                _c(
                  "label",
                  { staticClass: "form-label", attrs: { for: "tags" } },
                  [_vm._v("Tags (comma separated)")]
                ),
                _vm._v(" "),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.tagsInput,
                      expression: "tagsInput"
                    }
                  ],
                  staticClass: "form-control",
                  attrs: {
                    id: "tags",
                    type: "text",
                    placeholder: "tag1, tag2, tag3"
                  },
                  domProps: { value: _vm.tagsInput },
                  on: {
                    input: function($event) {
                      if ($event.target.composing) return
                      _vm.tagsInput = $event.target.value
                    }
                  }
                })
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "modal-footer" }, [
              _c(
                "button",
                {
                  staticClass: "btn btn-primary",
                  attrs: { type: "submit", disabled: _vm.isSubmitting }
                },
                [
                  _vm._v(
                    "\n            " +
                      _vm._s(_vm.isSubmitting ? "Saving..." : "Save") +
                      "\n          "
                  )
                ]
              ),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "btn btn-secondary",
                  attrs: { type: "button" },
                  on: {
                    click: function($event) {
                      return _vm.$emit("close")
                    }
                  }
                },
                [_vm._v("\n            Cancel\n          ")]
              )
            ])
          ]
        )
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }